import store from '@/store'
import configs from '@/plugins/configs'
import { decryptAES } from '@/plugins/crypto'

let tokenRefreshIntervalId = null

/**
 * Build Keycloak logout URL with optional id_token_hint
 */
function buildLogoutUrl (idTokenHint = '') {
  let url = `${configs.keycloakurl}/realms/${configs.keycloakrealm}/protocol/openid-connect/logout?post_logout_redirect_uri=${window.location.origin}${process.env.BASE_URL}login&client_id=${configs.keycloakclientId}`
  if (idTokenHint && idTokenHint.trim()) {
    url += `&id_token_hint=${idTokenHint}`
  }
  return url
}

export function startTokenRefresh (keycloak, idletime, tokenexpiry) {
  if (tokenRefreshIntervalId) clearInterval(tokenRefreshIntervalId)

  tokenRefreshIntervalId = setInterval(() => {
    keycloak.updateToken(idletime)
      .then(refreshed => {
        if (refreshed) {
          // Update Vuex store with refreshed token
          store.commit('auth/UPDATE_TOKEN', keycloak.token)

          // Also sync to localStorage so other parts of the app
          // that read directly from localStorage get the new token.
          try {
            const vuexState = JSON.parse(localStorage.getItem('vuex') || '{}')
            vuexState.auth = vuexState.auth || {}
            vuexState.auth.tokenAPI = keycloak.token
            localStorage.setItem('vuex', JSON.stringify(vuexState))
          } catch (e) {
            console.warn('Could not sync refreshed token to localStorage', e)
          }
        }
      })
      .catch(() => {
        console.error('Failed to refresh token')
        stopTokenRefresh()
        setTimeout(() => {
          const kctokenhint = decryptAES(localStorage.getItem('kc_id_token')) || ''
          const logoutUrl = buildLogoutUrl(kctokenhint)
          window.location.href = logoutUrl
        }, 100)
        localStorage.clear()
        sessionStorage.clear()
        store.dispatch('auth/logout')
      })
  }, tokenexpiry * 1000 * 0.75)
}

export function stopTokenRefresh () {
  if (tokenRefreshIntervalId) {
    clearInterval(tokenRefreshIntervalId)
    tokenRefreshIntervalId = null
  }
}

// export function refreshTokenNow (keycloak, idletime, tokenexpiry) {
//   if (tokenRefreshIntervalId) clearInterval(tokenRefreshIntervalId)

//   tokenRefreshIntervalId = setInterval(() => {
//     return keycloak.updateToken(idletime)
//       .then(refreshed => {
//         if (refreshed) {
//           store.commit('auth/UPDATE_TOKEN', keycloak.token)
//           console.log('Token refreshed on demand')
//           return true
//         } else {
//           console.log('Token was still valid')
//           return false
//         }
//       })
//       .catch(() => {
//         stopTokenRefresh()
//         console.error('Failed to refresh token')
//         return false
//       })
//   }, tokenexpiry * 1000 * 0.75)
// }

export function refreshTokenNow (keycloak, minValidity = 30) {
  if (!keycloak?.refreshToken) {
    console.warn('No refresh token — session likely expired')
    return Promise.resolve(false)
  }

  return keycloak.updateToken(minValidity)
    .then(refreshed => {
      if (refreshed) {
        // Update both store and localStorage
        store.commit('auth/UPDATE_TOKEN', keycloak.token)

        // Update localStorage to sync Vuex state
        const vuexState = JSON.parse(localStorage.getItem('vuex') || '{}')
        vuexState.auth = vuexState.auth || {}
        vuexState.auth.tokenAPI = keycloak.token
        localStorage.setItem('vuex', JSON.stringify(vuexState))
        return true
      } else {
        console.log(' Token was still valid, no refresh needed')
        return true
      }
    })
    .catch(err => {
      console.error(' Failed to refresh token', err)
      return false
    })
}
